import React, { useState  } from 'react';
import { Box, Button, Input } from '@chakra-ui/react';
import { ScaleFade } from '@chakra-ui/transition';
import { VStack } from '@chakra-ui/layout';
import Keypad from './Keypad';

interface ScoreInputProps {
  playerName: string;
  onSubmit: (score: number) => void;
  onUndoLast: () => void;
  canUndo: boolean;
}

const ScoreInput: React.FC<ScoreInputProps> = ({ playerName, onSubmit, onUndoLast, canUndo }) => {
  const [score, setScore] = useState('');
  const [touched, setTouched] = useState(false);

  const handleSubmit = (score: string) => {
    const num = parseInt(score, 10);
    if (isNaN(num) || num < 0) {
      return;
    }
    onSubmit(num);
    setScore('');
    setTouched(false);
  };

  return (
    <ScaleFade in={true} initialScale={0.95}>
      <Box maxW="sm" mx="auto" mb={8} px={4}>
        <VStack spacing={4}>
          {/* Mobile Keypad */}
          <Box display={{ base: 'block', md: 'none' }} w="100%">
            <Keypad
              value={score}
              onChange={(val) => {
                setScore(val);
                setTouched(true);
              }}
              onSubmit={(val) => {
                handleSubmit(val);
              }}
            />
          </Box>
          {/* Desktop Input */}
          <Box display={{ base: 'none', md: 'block' }} w="100%">
            <Input
              placeholder={`Enter ${playerName}'s score`}
              value={score}
              onChange={e => {
                setScore(e.target.value.replace(/\D/g, ''));
                setTouched(true);
              }}
              type="number"
              min={0}
              size="lg"
              bg="whiteAlpha.900"
              fontWeight="bold"
              _focus={{ borderColor: 'teal.400', boxShadow: '0 0 0 2px #81e6d9' }}
              w="100%"
              onKeyDown={e => {
                if (e.key === 'Enter') handleSubmit(score);
              }}
            />
            <Button
              colorScheme="teal"
              w="100%"
              size="lg"
              borderRadius="xl"
              fontWeight="bold"
              fontSize="xl"
              mt={2}
              onClick={() => handleSubmit(score)}
              disabled={!score}
              boxShadow="lg"

            >
              Submit
            </Button>
          </Box>
          <Button
         
            onClick={onUndoLast}
            disabled={!canUndo}
            colorScheme="teal"
            w="100%"
            size="lg"
            borderRadius="xl"
            fontWeight="bold"
            fontSize="xl"
            mt={2}
            boxShadow="lg"
            px={20}

          >
            Undo Last
          </Button>
        </VStack>
      </Box>
    </ScaleFade>
  );
};

export default ScoreInput;
